module.exports = __webpack_public_path__ + "static/img/015_TO8_1476_og.3a571c6.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/015_TO8_1476_og.jpg
// module id = S6Va
// module chunks = 0